import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError,  throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { Page } from '../model/page.model';
import { Product } from '../model/product.model';
import { List } from '../model/list.model';
import { Data } from '../model/data.model';
import { Banner } from '../model/banner.model';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(private http: HttpClient) { }

  getAllProducts(page: Page): Observable<Data<List<Product>>> {
    return this.http.post<Data<List<Product>>>(`${environment.apiURL}/Product/GetAllProducts`, page).pipe(
      catchError(this.handleError)
    );
  }

  getProductDetailsById(productId: string): Observable<Data<Product[]>> {
    return this.http.post<Data<Product[]>>(`${environment.apiURL}/Product/ProductDetails`, { 'productSlugName': productId }).pipe(
      catchError(this.handleError)
    )
  }

  getBannerData(): Observable<Data<Banner[]>> {
    return this.http.get<Data<Banner[]>>(`${environment.apiURL}/Product/GetBannerData`).pipe(
      catchError(this.handleError)
    )
  }

  getBestSellerProducts(page: Page): Observable<Data<List<Product>>> {
    return this.http.post<Data<List<Product>>>(`${environment.apiURL}/Product/GetAllBestSellerProducts`, page).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(err: HttpErrorResponse): Observable<never> {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${err.error.message}`;
    }
    else {
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;

    }
    return throwError(() => errorMessage);
  }

}
